import { type FlowProducedType } from 'flow-schema';

import { Text, isDefined } from 'common';

import { FieldReferenceCodeMirror } from '../../../../Runs/Run/Drawer/ContentTabs/FieldReference/CodeMirror';
import { type OutputContentProps } from '../../types';

export function UpdateNotableObjectOutputContent(props: OutputContentProps<FlowProducedType.Any>) {
  const { isFullHeightView } = props;
  const returnValue: unknown = props.returnValue;
  if (!isDefined(returnValue)) {
    return <Text>No updates were made</Text>;
  }

  return (
    <FieldReferenceCodeMirror
      content={JSON.stringify(returnValue, null, 2)}
      isFullHeightView={isFullHeightView}
    />
  );
}
